(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     *
     */

    angular
        .module('ihh-common-web')
        .factory('MathUtilities', MathUtilities);

    function MathUtilities() {
        /*
         * Modified from original source for use as a factory method:
        * https://github.com/jprichardson/least-squares
        *
        * Original license:
        *
        * (The MIT License)
        *
        * Copyright (c) 2013, JP Richardson <jprichardson@gmail.com>
        *
        * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files
        * (the 'Software'), to deal in the Software without restriction, including without limitation the rights to use, copy, modify,
        * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
        * furnished to do so, subject to the following conditions:
        *
        * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
        *
        * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
        * WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
        * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
        * ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
        */
        function LeastSquares(X, Y, computeError, ret) {
            if (typeof computeError === 'object') {
                ret = computeError;
                computeError = false;
            }

            if (typeof ret === 'undefined') {
                ret = {};
            }

            var sumX = 0;
            var sumY = 0;
            var sumXY = 0;
            var sumXSq = 0;
            var N = X.length;

            for (var i = 0; i < N; ++i) {
                sumX += X[i];
                sumY += Y[i];
                sumXY += X[i] * Y[i];
                sumXSq += X[i] * X[i];
            }

            ret.m = ((sumXY - sumX * sumY / N)) / (sumXSq - sumX * sumX / N);
            ret.b = sumY / N - ret.m * sumX / N;

            if (computeError) {
                var varSum = 0;
                for (var j = 0; j < N; ++j) {
                    varSum += (Y[j] - ret.b - ret.m * X[j]) * (Y[j] - ret.b - ret.m * X[j]);
                }

                var delta = N * sumXSq - sumX * sumX;
                var vari = 1.0 / (N - 2.0) * varSum;

                ret.bErr = Math.sqrt(vari / delta * sumXSq);
                ret.mErr = Math.sqrt(N / delta * vari);
            }

            return ret;
        }

        return {
            lsq: LeastSquares
        };
    }
})();